import { Command, CommandMan, CommandType, type CommandAutomate, type State as StateType } from "@eisox/api/core-api";

import { m } from "~/paraglide/messages";

interface GetActuatorstates {
  state: StateType | number | undefined;
  commandAutomate: CommandAutomate | number | undefined;
  commandMan: CommandMan | undefined;
  defect: boolean;
}

interface ActuatorState {
  state: StateType | CommandAutomate | number | null;
  warning?: string;
}

export const getActuatorState = ({ state, commandAutomate, commandMan, defect }: GetActuatorstates): ActuatorState => {
  if (defect) return { state: null };
  if (commandMan === CommandMan.MANUAL) {
    if (state !== undefined) {
      return { state: state };
    }
    return {
      state: null,
      warning: m.air_handler_unit_actuator_warning_1(),
    };
  }
  if (state !== undefined) {
    return {
      state: state,
      warning: commandMan === undefined ? m.air_handler_unit_actuator_warning_3() : undefined,
    };
  }
  if (commandAutomate !== undefined) {
    return {
      state: commandAutomate,
      warning:
        commandMan === undefined ? m.air_handler_unit_actuator_warning_4() : m.air_handler_unit_actuator_warning_2(),
    };
  }
  return {
    state: null,
    warning: m.air_handler_unit_actuator_warning_5(),
  };
};

export const isAutoManualOrForcing = (commandMan?: CommandMan, command?: Command): "auto" | "manual" | "forcing" => {
  if (commandMan === CommandMan.MANUAL) return "manual";
  if (command === Command.MANUAL) return "forcing";
  return "auto";
};

const TWO_SPEED_LABELS: Partial<Record<number, "0" | "1" | "3">> = { 0: "0", 1: "1", 2: "3" };

const THREE_SPEED_LABELS: Partial<Record<number, "0" | "1" | "2" | "3">> = { 0: "0", 1: "1", 2: "2", 3: "3" };

/** A two-speed actuator reports its high speed as 2. A state outside the speeds reads as no value. */
export const getSpeedLabel = (commandType: CommandType, state: number): string => {
  const speed = (commandType === CommandType.TWO_SPEED ? TWO_SPEED_LABELS : THREE_SPEED_LABELS)[state];
  return speed === undefined ? "--" : m.actuator_speed({ state: speed });
};
